<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/forword">Foreword, by Dr. Gregory E. Thornton</a></p>
<p class="toc"><a href="#/preface">Preface: What Schools Mean to Us</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">A Brief History of Milwaukee’s Public Schools</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Quiet Garfield Avenue School Is an Architectural Treasure</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">1891 Walker’s Point School Salutes Albert Kagel</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Brown Street to Groppi High</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Twins, Triplets and Even Quadruplets in Vintage Milwaukee Schoolhouses</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">A Closer Look at Neeskara</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Tracing the Decades at Maryland Avenue School</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">High Schools Carve a Special Place in Our Memories</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Bay View Feared Closure of Mound Street School</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Potter’s Legacy Lives On at Gaenslen School</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Looking At, and Into, Trowbridge Street School</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Architectural Gems “Haunted” by Schoolhouse Echoes</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Up in Smoke: Three Buildings Lost to Fire</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">New Uses for Old Schools</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">The State of Milwaukee’s Vintage Schoolhouses</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Lost Milwaukee Schoolhouse Treasures</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Ten Must-See Milwaukee Schoolhouses</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix: MPS Charts</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4d728b2c